import { useId } from 'react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { ContactLink, GetStartedLink } from '@/constants/navigation';

export function CtaBand({ title, description }) {
  const titleId = useId();

  return (
    <section aria-labelledby={titleId} className="pad-grid border-t border-grid">
      <div className="section-container flex flex-col gap-8 py-16 sm:py-20 lg:flex-row lg:items-center lg:justify-between lg:gap-16">
        <div className="max-w-2xl">
          <h2 id={titleId} className="text-3xl font-extrabold leading-tight tracking-tight text-balance text-graphite sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-steel">{description}</p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-3">
          <Button asChild size="lg">
            <Link to={GetStartedLink.to}>{GetStartedLink.label}</Link>
          </Button>
          <Button asChild size="lg" variant="outline">
            <Link to={ContactLink.to}>{ContactLink.label}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}